export const GoogleAnalyticsEvents = {
    PasswordVisibilityToggleButton: "button_toggle_password_visibility",
    RememberMeCheckbox: "checkbox_remember_me",
    LoginButton: "button_login",
    FacebookLoginButton: "button_facebook_login",
    GoogleLoginButton: "button_google_login",
    SignupButton: "button_signup",
    GoToLoginPageButton: "button_goto_login_page",
    SendResetPasswordLinkButton: "button_send_reset_password_link",
    ReturnToLoginLink: "link_return_to_login",
    ResetPasswordButton: "button_reset_password",
    SendResetPasswordLinkAgainButton: "button_send_reset_password_link_again",
    LoginOrRegisterButton: "button_login_or_register",
    MyDashboardButton: "button_my_dashboard",
    DonateNowButton: "button_donate_now",
    LoginButtonInDonationDialog: "button_login_donation_dialog",
    BrowseAllButton: "button_browse_all",
    SeeDetailsLink: "link_see_details",
    SelectCandidateButton: "button_select_candidate",
    SelectCCAButton: "button_select_cca",
    GeneralDonationButton: "button_general_donation",
    SelectCandidateSearch: "search_select_candidate",
    CurrencyChangeEvent: "event_currency_change",
    PredefinedAmountButton: "button_predefined_amount",
    OneTimePaymentButton: "button_one_time_payment",
    RecurringPaymentButton: "button_recurring_payment",
    MonthlyFrequencyButton: "button_monthly_frequency",
    YearlyFrequencyButton: "button_yearly_frequency",
    DailyFrequencyButton: "button_daily_frequency",
    PaymentTypeButton: "button_payment_type",
    ProceedToPaymentButton: "button_proceed_to_payment",
    TotalDonationsDateFilter: "date_filter_total_donations",
    RecurringDonationCancellationsDateFilter: "date_filter_recurring_donation_cancellations",
    ViewCampaignButton: "button_view_campaign",
    ViewDonationsButton: "button_view_donations",
    SearchBar: "search_bar",
    FilterButton: "button_filter",
    RoleFilter: "select_dropdown_role",
    ViewDetailsButton: "button_view_details",
    CommunicationPreference: "select_dropdown_communication_preference",
    ClearFilterButton: "button_clear_filter",
    ClearFilterCrossButton: "button_clear_filter_cross",
    PaginationPageChangeEvent: "event_pagination_page_change",
    PaginationRowsPerPageChangeEvent: "event_pagination_rows_per_page_change",
    EmailButton: "button_email",
    SMSButton: "button_sms",
    PhoneButton: "button_phone",
    NotesButton: "button_notes",
    CampaignFilter: "select_dropdown_campaign",
    AmountRangeFilters: "amount_filter",
    DateRangeFilter: "date_filter",
    PaymentMethodFilter: "select_dropdown_payment_method",
    StatusFilter: "select_dropdown_status",
    AddNoteButton: "button_add_note",
    SeeMoreButton: "button_see_more",
    SeeLessButton: "button_see_less",
    ArrowBackButton: "button_arrow_back",
    DonationIdLink: "link_donation_id",
    EditOfflinePaymentButton: "button_edit_offline_payment",
    ResetButton: "button_reset",
    UpdateButton: "button_update",
    RadioButton: "button_radio",
    TabsButton: "button_tabs",
    ExportButton: "button_export",
    DownloadButton: "button_download",
    RefundRequestButton: "button_refund_request",
    ModifyDonationButton: "button_modify_donation",
    CreateCampaignButton: "button_create_campaign",
    EditCampaignButton: "button_edit_campaign",
    DeleteCampaignButton: "button_delete_campaign",
    PublishCampaignButton: "button_publish_campaign",
    UnpublishCampaignButton: "button_unpublish_campaign",
    SaveButton: "button_save",
    SaveAndPublishButton: "button_save_and_publish",
    ApproveButton: "button_approve",
    RejectButton: "button_reject",
    GenderFilter: "select_dropdown_gender",
    UrgencyFilter: "select_dropdown_urgency",
    RecoveryStatusFilter: "select_dropdown_recovery_status",
    ActivationStatusFilter: "select_dropdown_activation_status",
    CreatePatientButton: "button_create_patient",
    EditPatientButton: "button_edit_patient",
    DeletePatientButton: "button_delete_patient",
    ActivatePatientButton: "button_activate_patient",
    DeactivatePatientButton: "button_deactivate_patient",
    ChooseImageButton: "button_choose_image",
    CreateDeservingItemButton: "button_create_deserving_item",
    EditDeservingItemButton: "button_edit_deserving_item",
    DeleteDeservingItemButton: "button_delete_deserving_item",
    ActivateDeservingItemButton: "button_activate_deserving_item",
    DeactivateDeservingItemButton: "button_deactivate_deserving_item",
    DeservingItemTypeFilter: "select_dropdown_deserving_item_type",
    CreateReportButton: "button_create_report",
    EditReportButton: "button_edit_report",
    DeleteReportButton: "button_delete_report",
    PublishReportButton: "button_publish_report",
    UnpublishReportButton: "button_unpublish_report",
    BrowseFileButton: "button_browse_file",
    CreateUserButton: "button_create_user",
    EditUserButton: "button_edit_user",
    DeleteUserButton: "button_delete_user",
    ActivateUserButton: "button_activate_user",
    DeactivateUserButton: "button_deactivate_user",
    EditProfileButton: "button_edit_profile",
    ListOfSponsorshipDateFilter: "date_filter_list_of_sponsorship",
    UserMenu: "menu_user",
    LogoutButton: "button_logout",
    BreadcrumbLink: "link_breadcrumb",
};
